/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_contains.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns true if the first argument\ncontains the second argument.\nThis is the inverse of RANGE_WITHIN; equivalent to `RANGE_WITHIN(b, a)`.\nSupports (date_range, date) and (date_range, date_range). The first argument must be a date_range.',
  examples: [
    'FROM employees\n| WHERE RANGE_CONTAINS(TO_DATE_RANGE("1985-02-01..1985-03-01"), hire_date)\n| KEEP emp_no, hire_date\n| SORT emp_no',
  ],
  params: {
    left: 'Container range.',
    right: 'Value to test (point or range).',
  },
};

export default docs;
